import React, { useState, useEffect } from "react";

import { t } from "i18next";
import { notification } from "antd";

import { Container } from "./style";

import PenIcon from "../../../components/shared/Icons/PenIcon";
import PencilIcon from "../../../components/shared/Icons/PencilIcon";
import ImageIcon from "../../../components/shared/Icons/ImageIcon";
import ThreeBarsIcon from "../../../components/shared/Icons/ThreeBarsIcon";
import NewsLetterIcon from "../../../components/shared/Icons/NewsLetterIcon";
import SmartPhoneIcon from "../../../components/shared/Icons/SmartPhoneIcon";
import { ChannelContext, LoggedUser } from "../../../context/channel";
import settingsPages from "../../../components/dashboard/utils/settingsPages";
import { dashboardApi } from "../../../api/DashboardApi";
import PageWrapper from "../../../components/dashboard/pageWrapper/PageWrapper";
import EventialsHeader from "../../../components/shared/EventialsHeader";
import TopBar from "../../../components/dashboard/topBar/TopBar";
import LeftMenu from "../../../components/dashboard/leftMenu/LeftMenu";
import IconsTopBar from "../../../components/dashboard/IconsTopBar";
import MainInformations from "../../../components/dashboard/mainInformations/MainInformations";
import BasicInformation from "../../../components/dashboard/BasicInformation/BasicInformation";
import Appearance from "../../../components/dashboard/Appearance/Appearance";
import BannerLoad from "../../../components/dashboard/BannerLoad/BannerLoad";
import DescriptionBlock from "../../../components/dashboard/DescriptionBlock/DescriptionBlock";
import Newsletter from "../../../components/dashboard/Newsletter/Newsletter";
import ConfirmPublicationModal from "../../../components/shared/confirmPublicationModal/ConfirmPublicationModal";
import { API_URL, WL_URL } from "../../../settings";
import Footer from "../../../components/dashboard/Footer/Footer";

const settings = [
  {
    title: t('dashboard.basicInformation.title'),
    value: "basicInformation",
    icon: <PenIcon size="18px" />,
  },
  { 
    title: t('dashboard.appearance.title'), 
    value: "appearance", 
    icon: <PencilIcon size="18px" /> },
  { 
    title: t('dashboard.banners.title'), 
    value: "banners", 
    icon: <ImageIcon size="18px" /> 
  },
  {
    title: t('dashboard.description.title'),
    value: "descriptionBlock",
    icon: <ThreeBarsIcon size="18px" />,
  },
  {
    title: t('dashboard.newsletter.title'),
    value: "newsletter",
    icon: <NewsLetterIcon size="18px" />,
  },
  { 
    title: t('dashboard.footer.title'), 
    value: "footer", 
    icon: <SmartPhoneIcon size="18px" /> 
  },
];

const DashboardCustomization = () => {
  const [selectedSettingsPage, setSelectedSettingsPage] =
    useState<string>("basicInformation");
  const [selectedSettingsPageTitle, setSelectedSettingsPageTitle] =
    useState<string>(settings[0].title);
  const [isShowModal, setIsShowModal] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const { channel } = React.useContext(ChannelContext);

  useEffect(() => {
    dashboardApi.getAuthentication().then((response: LoggedUser | string) => {
      if (typeof(response) === "string" && !window.location.hostname.includes("localhost")){
        window.location.href = API_URL + "/login";
      }
      else {
        setIsLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    const page = settingsPages.find((p) => p.value === selectedSettingsPage);
    if (page) setSelectedSettingsPageTitle(page.title);
  }, [selectedSettingsPage]);

  const handlePublish = () => {
    setIsShowModal(false);              
        return dashboardApi.publishWhitelabel(channel).then((response: any ) => {
            if (response.message)  {               
                notification.success({
                    message: response.message,
                });
            }
        });
  }

  return (
    isLoading ? (<></>) : (
      <PageWrapper>
      <EventialsHeader />
      <Container>
        <TopBar
          setIsShowModal={setIsShowModal}
          pageTitle={selectedSettingsPageTitle}
          selectedSettingsPage={selectedSettingsPage}
        />
        <div className="cards-container">
          <LeftMenu
            selectedSettingsPage={selectedSettingsPage}
            setSelectedSettingsPage={setSelectedSettingsPage}
          />
          <MainInformations>
            <IconsTopBar
              selected={selectedSettingsPage}
              settings={settings}
              setSelected={setSelectedSettingsPage}
            />
            {selectedSettingsPage === "basicInformation" ? (
              <BasicInformation />
            ) : selectedSettingsPage === "appearance" ? (
              <Appearance />
            ) : selectedSettingsPage === "banners" ? (
              <BannerLoad />
            ) : selectedSettingsPage === "descriptionBlock" ? (
              <DescriptionBlock />
            ) : selectedSettingsPage === "newsletter" ? (
              <Newsletter />
            ) : selectedSettingsPage === "footer" ? (
              <Footer />
            ) : selectedSettingsPage === "transmissionPage" ? (
              <BasicInformation />
            ) : null}
          </MainInformations>
        </div>
      </Container>
      {isShowModal && (
        <ConfirmPublicationModal 
          setIsShowModal={setIsShowModal} 
          handlePublish={handlePublish} 
          linkWL={WL_URL + "/" + channel} 
        />
        )}
    </PageWrapper>
    ) 
  );
};

export default DashboardCustomization;
